<template>
  <div class="footer-wrapper">
    <!-- 桌面端：保持原有6列布局 -->
    <div class="list-wrap desktop-footer">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="title">买家服务</div>
          <div class="li">供应商入驻</div>
          <div class="li">电商分销</div>
          <div class="li">API采购</div>
        </el-col>
        <el-col :span="4">
          <div class="title">卖家服务</div>
          <div class="li">卡券回收</div>
          <div class="li">API供应</div>
        </el-col>
        <el-col :span="4">
          <div class="title">文档中心</div>
          <div class="li">业务教程</div>
          <div class="li">常见问题</div>
        </el-col>
        <el-col :span="4">
          <div class="title">关于我们</div>
          <div class="li">企业文化</div>
          <div class="li">意见反馈</div>
        </el-col>
        <el-col :span="4">
          <div class="title">联系我们</div>
          <div class="li">电话：4000000981</div>
          <div class="li">邮箱：cyx@birdicloud.com</div>
        </el-col>
        <el-col :span="4" class="col-right">
          <div class="title code">
            <img src="../assets/qrCode.jpg" alt="">
            <div class="name">皆淘淘公众号</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 移动端：折叠面板布局 -->
    <div class="list-wrap mobile-footer">
      <div class="accordion" v-for="section in footerSections" :key="section.name">
        <div class="accordion-header" @click="toggleSection(section.name)">
          <span class="accordion-title">{{ section.name }}</span>
          <span class="accordion-arrow" :class="{ expanded: activeSections.includes(section.name) }">
            <i class="el-icon-arrow-down"></i>
          </span>
        </div>
        <div class="accordion-body" v-show="activeSections.includes(section.name)">
          <div class="li" v-for="item in section.items" :key="item">{{ item }}</div>
        </div>
      </div>

      <!-- 联系我们（始终展开） -->
      <div class="contact-block">
        <div class="contact-title">联系我们</div>
        <div class="contact-item">电话：4000000981</div>
        <div class="contact-item">邮箱：cyx@birdicloud.com</div>
      </div>

      <!-- 公众号二维码 -->
      <div class="qrcode-block">
        <img src="../assets/qrCode.jpg" alt="">
        <div class="name">皆淘淘公众号</div>
      </div>
    </div>

    <div class="filing-wrap">
      <div>Copyright © 神鸟云（北京）科技有限公司 ｜ <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2025135773号-1</a> ｜ <a href="javascript:void(0)" @click="lookLicense">营业执照</a> ｜ <a href="javascript:void(0)" @click="privacy">隐私政策</a></div>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      activeSections: [],
      footerSections: [
        { name: '买家服务', items: ['供应商入驻', '电商分销', 'API采购'] },
        { name: '卖家服务', items: ['卡券回收', 'API供应'] },
        { name: '文档中心', items: ['业务教程', '常见问题'] },
        { name: '关于我们', items: ['企业文化', '意见反馈'] },
      ]
    }
  },
  methods: {
    toggleSection(name) {
      const idx = this.activeSections.indexOf(name)
      if (idx > -1) {
        this.activeSections.splice(idx, 1)
      } else {
        this.activeSections.push(name)
      }
    },
    lookLicense() {
      window.open('https://example.com/path/to/your/image.jpg', '_blank')
    },
    privacy() {
      window.scrollTo(0, 0);
      this.$router.push('/privacy')

    }
  }
}
</script>
<style scoped lang="less">
  .footer-wrapper {
    width: 100%;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    box-sizing: border-box;

    // 移动端面板默认隐藏
    .mobile-footer {
      display: none;
    }

    // ========== 桌面端 ==========
    .desktop-footer {
      width: 100%;
      padding: 0 17%;
      box-sizing: border-box;
      display: flex;
      /deep/ .el-row {
        width: 100%;
        .col-right {
          border-left: 1px solid #c0c0c0;
        }
        .title {
          font-size: 16px;
          font-weight: bold;
          img {
            width: 140px;
          }
        }
        .code {
          text-align: center;
          .name {
            margin-top: 10px;
          }
        }
        .li {
          font-size: 14px;
          margin-top: 10px;
          color: #666666;
        }
      }
    }

    .filing-wrap {
      margin-top: 40px;
      color: #999999;
      font-size: 14px;
      text-align: center;
      a {
        text-decoration: none;
        color: inherit;
      }
    }
  }

  // ========== 移动端适配 ==========
  @media (max-width: 768px) {
    .footer-wrapper {
      padding: 0;

      // 隐藏桌面端
      .desktop-footer {
        display: none;
      }

      // 显示移动端折叠面板
      .mobile-footer {
        display: block;
        width: 100%;
        box-sizing: border-box;

        // 折叠面板
        .accordion {
          border-bottom: 1px solid #e8e8e8;

          .accordion-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 16px;
            cursor: pointer;
            user-select: none;
            -webkit-tap-highlight-color: transparent;

            &:active {
              background: rgba(0, 0, 0, 0.03);
            }

            .accordion-title {
              font-size: 15px;
              font-weight: 600;
              color: #333;
            }

            .accordion-arrow {
              font-size: 12px;
              color: #999;
              transition: transform 0.25s ease;

              &.expanded {
                transform: rotate(180deg);
              }
            }
          }

          .accordion-body {
            padding: 0 16px 14px 16px;

            .li {
              font-size: 13px;
              color: #666;
              padding: 6px 0;
            }
          }
        }

        // 联系我们（始终可见）
        .contact-block {
          padding: 16px;
          border-bottom: 1px solid #e8e8e8;

          .contact-title {
            font-size: 15px;
            font-weight: 600;
            color: #333;
            margin-bottom: 8px;
          }

          .contact-item {
            font-size: 13px;
            color: #666;
            padding: 3px 0;
          }
        }

        // 二维码
        .qrcode-block {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 24px 16px;

          img {
            width: 120px;
            border-radius: 6px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          .name {
            margin-top: 10px;
            font-size: 13px;
            color: #666;
          }
        }
      }

      .filing-wrap {
        margin-top: 0;
        padding: 20px 16px;
        font-size: 11px;
        color: #aaa;
        line-height: 1.8;
        text-align: center;
        background: #eee;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue